//Log Manipulation Routes

import { lazy } from 'react'
import { createRoute } from '@/helpers/createRoute'

const LogManipulationModules = lazy(() => import('@/pages/LogManipulationModules'))
// const SchedulerManager = lazy(() => import('@/modules/log-manipulation-module/SchedulerManager'))
const EditLogReport = lazy(() => import('@/modules/log-manipulation-module/EditLogReport'))
const InventoryStatusReport = lazy(
  () => import('@/modules/log-manipulation-module/InventoryStatusReport')
)
const PendingStabilityInventory = lazy(
  () => import('@/modules/log-manipulation-module/PendingStabilityInventory')
)
const PendingStabilityCycleStartDate = lazy(
  () => import('@/modules/log-manipulation-module/PendingStabilityCycleStartDate')
)
const PendingStabilityCycleEndDate = lazy(
  () => import('@/modules/log-manipulation-module/PendingStabilityCycleEndDate')
)
const PendingStabilityRequests = lazy(
  () => import('@/modules/log-manipulation-module/PendingStabilityRequests')
)
const TakeExtraInventoryForSample = lazy(
  () => import('@/modules/log-manipulation-module/TakeExtraInventoryForSample')
)
const RestoreInventoryByStudySelection = lazy(
  () => import('@/modules/log-manipulation-module/RestoreInventoryByStudySelection')
)
const SampleScheduler = lazy(() => import('@/modules/log-manipulation-module/SampleScheduler'))
// const InProgress = lazy(() => import('@/pages/InProgress'))

export const logManipulationRoutes = {
  ...createRoute('/logManipulationModules', <LogManipulationModules />),
  children: [
    createRoute('sampleScheduler', <SampleScheduler />),
    createRoute('pendingStabilityRequests', <PendingStabilityRequests />),
    createRoute('pendingStabilityInventory', <PendingStabilityInventory />),
    createRoute('pendingStabilityCycleStartDate', <PendingStabilityCycleStartDate />),
    createRoute('pendingStabilityCycleEndDate', <PendingStabilityCycleEndDate />),
    createRoute('takeExtraInventoryForSample', <TakeExtraInventoryForSample />),
    createRoute('restoreInventoryByStudySelection', <RestoreInventoryByStudySelection />),
    createRoute('inventoryStatusReport', <InventoryStatusReport />),
    createRoute('editLogReport', <EditLogReport name="Edit Log Report" />)
  ]
}
